// extracted by mini-css-extract-plugin
export default {"scroll-progress-container":"ScrollProgress_scroll-progress-container__xGWRu","scroll-progress-bar":"ScrollProgress_scroll-progress-bar__VImGk"};